<!-- <p>printable-activity-dialog works!</p> -->
<div class="printable-activity-container">
  <div class="aumye-header">
    <button
      *ngIf="isShowPrintPreview"
      mat-mini-fab
      (click)="isShowPrintPreview = false"
    >
      <mat-icon>arrow_back</mat-icon></button
    ><button *ngIf="!isShowPrintPreview" mat-mini-fab mat-dialog-close>
      <mat-icon>clear</mat-icon>
    </button>
    Print Activity
  </div>
  <div
    *ngIf="!isShowPrintPreview"
    style="margin: 10px; display: flex; justify-content: flex-end"
  >
    <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
      <mat-label>Search</mat-label>
      <input matInput (keyup)="applyFilter($event)" #input />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
  </div>

  <div class="visitors-table" *ngIf="!isShowPrintPreview">
    <table mat-table [dataSource]="filtered">
      <ng-container matColumnDef="no">
        <th mat-header-cell *matHeaderCellDef>No</th>
        <td mat-cell *matCellDef="let element; let i = index">
          {{ i + 1 }}
        </td>
      </ng-container>
      <ng-container matColumnDef="id">
        <th style="border-right: 1px solid" mat-header-cell *matHeaderCellDef>
          Visitor Name
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ row.visitorID }}
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th style="border-right: 1px solid" mat-header-cell *matHeaderCellDef>
          Visitor Name
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ row.firstName + " " + row.lastName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="contact">
        <th style="border-right: 1px solid" mat-header-cell *matHeaderCellDef>
          Contact
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ row.phoneNumber }}
        </td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th style="border-right: 1px solid" mat-header-cell *matHeaderCellDef>
          Date
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ row.visitDateTime | date : "E, MMMM d, y" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="host">
        <th style="border-right: 1px solid" mat-header-cell *matHeaderCellDef>
          Host Name
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ row.hostName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="security">
        <th
          style="border-right: 1px solid; text-align: center"
          mat-header-cell
          *matHeaderCellDef
        >
          Status
        </th>
        <td
          style="border-right: 1px solid; text-align: center"
          mat-cell
          *matCellDef="let row"
        >
          <button
            [ngStyle]="
              row.securityStatus == 1 ||
              row.securityStatus == 4 ||
              row.securityStatus == 5
                ? { 'background-color': 'green' }
                : row.securityStatus == -1 || row.securityStatus == 3
                ? { 'background-color': '#FFBF00' }
                : { 'background-color': 'red' }
            "
            class="security-button"
            mat-raised-button
          >
            {{ row.securityStatus == 0 ? "Un-verified" : "Verified" }}
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="Details">
        <th
          style="text-align: center"
          mat-header-cell
          *matHeaderCellDef
          aria-label="row actions"
        >
          Action
        </th>
        <td style="text-align: center" mat-cell *matCellDef="let element">
          <button (click)="onShowDetails(element)" mat-raised-button>
            Print
          </button>
        </td>
      </ng-container>
      <tr
        class="table-header"
        mat-header-row
        *matHeaderRowDef="displayedVisitorColumns; sticky: true"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: displayedVisitorColumns"></tr>
    </table>
    <div class="data-not-found" *ngIf="!filtered.length">
      {{ "No visitor Data available" | uppercase }}
    </div>
  </div>
</div>
<div class="button-container">
  <button
    (click)="printDocument()"
    *ngIf="isShowPrintPreview"
    mat-raised-button
  >
    Download Activity
  </button>
</div>
<div
  style="
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;
    max-height: 550px;
    overflow: auto;
  "
  *ngIf="isShowPrintPreview"
>
  <div
    [ngStyle]="
      !isClickedPrinting ? { 'max-height': '550px' } : { 'max-height': 'none' }
    "
    id="printable-area"
    class="grid-content-wrapper"
  >
    <div class="printable-area-wrapper">
      <div class="tile-header">Visitor Activity Report</div>
      <div class="row-wrapper">
        <div class="tile-label">Organization</div>
        <div class="tile-value">{{ orgName }}</div>
      </div>
      <div class="row-wrapper">
        <div class="tile-label">Visitor Name</div>
        <div class="tile-value">{{ visitorName }}</div>
      </div>
      <div class="row-wrapper">
        <div class="tile-label">Date</div>
        <div class="tile-value">
          {{ today | date : "dd-MM-yyyy HH:mm:ss" }}
        </div>
      </div>
      <div class="row-wrapper">
        <div class="tile-label">Printed By</div>
        <div class="tile-value">
          {{ printedBy }} | Role: {{ printedByRole | uppercase }}
        </div>
      </div>

      <div class="tile-sub-header">Summary</div>
      <div class="activity-content" *ngFor="let act of activity">
        <!-- DateTime Display -->
        <div style="font-weight: bold">
          DateTime: {{ act.commentAddDate | date : "dd-MM-yyyy HH:mm:ss" }}
        </div>

        <!-- Comment Text Display -->
        <div style="margin-top: 10px">{{ act.commentText }}</div>
      </div>
    </div>
  </div>
</div>
